import { FormShape } from "@suse-o11y/signal/form";

import type { DashboardMetricLabelValuesVariable } from "../../../../common/dashboard-spec";
import type { FormProcessor } from "../../_form-processor";
import { LabelNameFormProcessor, type LabelNameFormState } from "../_label-name";
import { SeriesSelectorsFormProcessor, type SeriesSelectorsFormState } from "../_series-selectors";

export type FormState = FormShape<{
	labelName: LabelNameFormState;
	selectors: SeriesSelectorsFormState;
}>;

export const Processor: FormProcessor<FormState, undefined | DashboardMetricLabelValuesVariable> = {
	fromSpec: (spec) =>
		FormShape({
			labelName: LabelNameFormProcessor.fromSpec(spec?.labelName),

			selectors: SeriesSelectorsFormProcessor.fromSpec(spec?.matchers),
		}),

	toSpec: ({ labelName, selectors }) => ({
		labelName,
		matchers: SeriesSelectorsFormProcessor.toSpec(selectors),
	}),
};
